import {
  Building2, Home, Fence, Trees, LayoutGrid, CarFront, Users, KeyRound, ShieldCheck,
  Sparkles, DoorOpen, Route, Leaf, Droplets, Car, LandPlot, Dumbbell, Baby, Fence as Gate,
} from "lucide-react";

const MAP = {
  Building2, Home, Fence, Trees, LayoutGrid, CarFront, Users, KeyRound, ShieldCheck,
  Sparkles, DoorOpen, Route, Leaf, Droplets, Car, LandPlot, Dumbbell, Baby, Gate,
};

export function getIcon(name) {
  return MAP[name] || Building2;
}

export const ICON_CHOICES = Object.keys(MAP);
